import React, { ComponentProps } from 'react';

import cx from 'classnames';

import EditableText from '../../../../../components/shared/EditableText';

interface Props extends ComponentProps<'div'> {
  value: string;
  readOnly: boolean;
  onEdit: (data: any) => void;
  isEditable: boolean;
}

const PageHeadline = (props: Props) => {
  const { value, onEdit, readOnly, isEditable, className } = props;

  if (isEditable) {
    const handleChange = (headline: string) => onEdit({ headline });

    return (
      <div {...props} className={cx(className, 'custom-headline-container')}>
        <EditableText text={value || ''} onChange={handleChange} isReadonly={readOnly} />
      </div>
    );
  }

  return (
    <div {...props} className={cx(className, 'left-side-headline')}>
      {value}
    </div>
  );
};

export default PageHeadline;
